import React from 'react';
import socialLinks from '../config/socialLinks';
import { trackEvent } from '../amplitude';
import '../styles/SocialLinks.css';

const SocialLinks = ({
  orientation = 'horizontal',
  size = 'md',
  className = '',
  showLabels = false,
  placement = 'footer',
}) => {
  const classes = [
    'social-links',
    `social-links--${orientation}`,
    `social-links--${size}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <nav className={classes} aria-label="Соціальні мережі BigSport">
      {socialLinks.map(({ key, label, url, icon: Icon }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`social-icon social-icon--${key}`}
          aria-label={`${label} BigSport`}
          title={`${label} BigSport`}
          onClick={() => trackEvent('social_link_clicked', {
            network: key,
            placement: placement === 'news_sidebar'
              && window.matchMedia?.('(max-width: 768px)').matches
              ? 'news_mobile_row'
              : placement,
          })}
        >
          <Icon aria-hidden="true" />
          {showLabels && (
            <span className="social-icon__label">{label}</span>
          )}
        </a>
      ))}
    </nav>
  );
};

export default SocialLinks;
